export enum DepotIdsEnum {
  REWRITES_DEPOT = 2,
  EY_ACTION_RETURN_DEVICE = 2,
}
